export default __webpack_public_path__ + "static/media/menu-white.18b29a8a.svg";